import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import configDB from "../data/customizer/config";
import { handleDetailResponse } from "utils/utils";
import envJson from "../env.json";

const SideBar = (props) => {
  const navigate = useNavigate();
  const [profileDetail, setProfileDetail] = useState({});
  const navigatpage = (navname) => {
    navigate(`${navname}`);
  };
  const [margin, setMargin] = useState(0);
  const [width, setWidth] = useState(0);
  const [hideLeftArrowRTL, setHideLeftArrowRTL] = useState(true);
  const [hideRightArrowRTL, setHideRightArrowRTL] = useState(true);
  const [hideRightArrow, setHideRightArrow] = useState(true);
  const [hideLeftArrow, setHideLeftArrow] = useState(true);
  const [mainMenu, setMainMenu] = useState([]);
  const wrapper = configDB.data.settings.sidebar.wrapper;
  const [layout, setLayout] = useState("rtl");
  const loginSelector = useSelector((state) => state.login);
  const permissionSelector = useSelector((state) => state.permission);
  const { response } = permissionSelector;
  useEffect(() => {
    if (response) {
      setMainMenu(response.sort((a, b) => a.sequence - b.sequence));
    }
  }, [permissionSelector]);
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    var currentUrl = window.location.pathname;
    // eslint-disable-next-line

    mainMenu.filter((items) => {
      if (items.path === currentUrl) setNavActive(items);
      if (!items.children) return false;
      // eslint-disable-next-line
      items.children.filter((subItems) => {
        if (subItems.path === currentUrl) setNavActive(subItems);
        if (!subItems.children) return false;
        // eslint-disable-next-line
        subItems.children.filter((subSubItems) => {
          if (subSubItems.path === currentUrl) setNavActive(subSubItems);
        });
      });
    });

    setTimeout(() => {
      const elmnt = document.getElementById("myDIV");
      const menuWidth = elmnt?.offsetWidth;
      // setMenuWidth(menuWidth)
      if (menuWidth > window.innerWidth) {
        setHideRightArrow(false);
        setHideLeftArrowRTL(false);
      } else {
        setHideRightArrow(true);
        setHideLeftArrowRTL(true);
      }
    }, 500);

    return () => {
      // eslint-disable-next-line
      window.addEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, []);

  const handleResize = () => {
    setWidth(window.innerWidth - 310);
  };

  const setNavActive = (item) => {
    // eslint-disable-next-line
    mainMenu.filter((menuItem) => {
      // eslint-disable-next-line
      if (menuItem != item) menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true;
      if (menuItem.children) {
        // eslint-disable-next-line
        menuItem.children.filter((submenuItems) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
    item.active = !item.active;
    setMainMenu([...mainMenu]);
  };

  // Click Toggle menu
  const toggletNavActive = (item) => {
    if (!item.active) {
      mainMenu.forEach((a) => {
        if (mainMenu.includes(item)) a.active = false;
        if (!a.children) return false;
        a.children.forEach((b) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
          if (!b.children) return false;
          b.children.forEach((c) => {
            if (b.children.includes(item)) {
              c.active = false;
            }
          });
        });
      });
    }
    item.active = !item.active;
    setMainMenu([...mainMenu]);
  };

  const scrollToRight = () => {
    const elmnt = document.getElementById("myDIV");
    const menuWidth = elmnt.offsetWidth;
    const temp = menuWidth + margin;
    if (temp < menuWidth) {
      setMargin(-temp);
      setHideRightArrow(true);
    } else {
      setMargin((margin) => (margin += -width));
      setHideLeftArrow(false);
    }
  };

  const scrollToLeft = () => {
    // If Margin is reach between screen resolution
    if (margin >= -width) {
      setMargin(0);
      setHideLeftArrow(true);
    } else {
      setMargin((margin) => (margin += width));
      setHideRightArrow(false);
    }
  };

  const scrollToLeftRTL = () => {
    if (margin <= -width) {
      setMargin((margin) => (margin += -width));
      setHideLeftArrowRTL(true);
    } else {
      setMargin((margin) => (margin += -width));
      setHideRightArrowRTL(false);
    }
  };

  const scrollToRightRTL = () => {
    const temp = width + margin;
    // Checking condition for remaing margin
    if (temp === 0) {
      setMargin(temp);
      setHideRightArrowRTL(true);
    } else {
      setMargin((margin) => (margin += width));
      setHideRightArrowRTL(false);
      setHideLeftArrowRTL(false);
    }
  };
  // Profile_Detail
  const userProfileDetailSelector =
    useSelector((state) => state?.userProfileUpdate) || {};

  useEffect(() => {
    if (userProfileDetailSelector.response) {
      const { response } = userProfileDetailSelector;
      if (response.status === 200) {
        const data = handleDetailResponse(response?.data);
        let baseUrl = data?.cp_id ? data?.profile_base_url : data?.base_url;
        setProfileDetail({ ...data, base_url: baseUrl });
      } else {
        setProfileDetail({});
      }
    } else {
      if (loginSelector.response && loginSelector.authToken) {
        if (loginSelector.response.status === 200) {
          setProfileDetail(handleDetailResponse(loginSelector?.response?.data));
        } else {
          setProfileDetail({});
        }
      }
    }
  }, [userProfileDetailSelector]);
  return (
    <div className="page-sidebar">
      <div className="main-header-left d-none d-lg-block">
        <div className="logo-wrapper">
          <a onClick={() => navigatpage("/")}>
            <div
              style={{
                backgroundImage: `url("/assets/images/JUSTOLOGO.jpg")`,
                width: 185,
                height: 75,
                cursor: "pointer",
                position: "relative",
                backgroundSize: "cover",
                backgroundPosition: "50%",
                backgroundRepeat: "no-repeat",
              }}
              className="side-logo"
            ></div>
          </a>
        </div>
      </div>
      <div className="sidebar custom-scrollbar">
        <div
          className="sidebar-user text-center"
          style={{ padding: "25px 5px" }}
        >
          <div style={{ display: "grid", placeItems: "center" }}>
            {profileDetail?.profile_picture ? (
              <div
                style={{
                  backgroundImage: `url(${profileDetail?.base_url}${profileDetail?.profile_picture})`,
                  width: 78,
                  height: 70,
                  borderRadius: "50%",
                  position: "relative",
                  backgroundSize: "cover",
                  backgroundPosition: "50%",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
            ) : (
              <span>
                <img
                  className="img-60 rounded-circle"
                  src="/assets/images/user.png"
                />
              </span>
            )}
            <div className="profile-edit">
              <a
                onClick={() => navigatpage("/edituserporfile")}
                style={{ bottom: "15px" }}
              >
                <img
                  style={{ width: "2", height: "18px", cursor: "pointer" }}
                  src="/assets/fonts/feather/edit.svg"
                  title="Edit Profile"
                />
              </a>
            </div>
          </div>
        </div>
        <div
          className="sidebar-user text-center"
          style={{ padding: "5px 10px" }}
        >
          <h6 className="f-14">
            {profileDetail?.user_name ||
              profileDetail?.agent_name ||
              profileDetail?.firstname ||
              "Justo Admin"}
            {"  "}
            {profileDetail?.lastname}
          </h6>
          <p>{profileDetail?.role_title}</p>
          <p>{envJson?.ENV === "STAG" ? "(ST-Version)" : ""}</p>
        </div>

        <ul
          className="sidebar-menu"
          id="myDIV"
          style={
            wrapper === "horizontal_sidebar"
              ? layout === "rtl"
                ? { marginRight: margin + "px" }
                : { marginLeft: margin + "px" }
              : { margin: "0px" }
          }
        >
          <li
            className={`left-arrow ${
              layout === "rtl"
                ? hideLeftArrowRTL
                  ? "d-none"
                  : ""
                : hideLeftArrow
                ? "d-none"
                : ""
            }`}
            onClick={
              wrapper === "horizontal_sidebar" && layout === "rtl"
                ? scrollToLeftRTL
                : scrollToLeft
            }
          >
            <i className="fa fa-angle-left"></i>
          </li>
          {mainMenu.map((menuItem, i) => {
            return menuItem.permission &&
              (envJson?.ENV === "PROD" // || envJson?.ENV === "STAG"
                ? menuItem.deploy
                : true) ? (
              <li className={`${menuItem.active ? "active" : ""}`} key={i}>
                {menuItem.sidebartitle ? (
                  <div className="sidebar-title">{menuItem.sidebartitle}</div>
                ) : (
                  ""
                )}

                {menuItem.type === "sub" ? (
                  <a
                    className="sidebar-header"
                    onClick={() => toggletNavActive(menuItem)}
                  >
                    {/* <Icon /> */}
                    <span>{menuItem.title}</span>
                    <i className="fa fa-angle-right pull-right"></i>
                  </a>
                ) : (
                  ""
                )}

                {menuItem.type === "link" ? (
                  <Link
                    to={`${process.env.PUBLIC_URL}${menuItem.path}`}
                    className={`sidebar-header ${
                      menuItem.active ? "active" : ""
                    }`}
                    onClick={() => toggletNavActive(menuItem)}
                  >
                    {/* <Icon /> */}
                    <span>{menuItem.title}</span>
                    {menuItem.children ? (
                      <i className="fa fa-angle-right pull-right"></i>
                    ) : (
                      ""
                    )}
                  </Link>
                ) : (
                  ""
                )}
                {menuItem.children ? (
                  <ul
                    className={`sidebar-submenu ${
                      menuItem.active ? "menu-open" : ""
                    }`}
                    style={
                      menuItem.active
                        ? { opacity: 1, transition: "opacity 500ms ease-in" }
                        : {}
                    }
                  >
                    {menuItem.children.map((childrenItem, index) => (
                      <li
                        key={index}
                        className={
                          childrenItem.children
                            ? childrenItem.active
                              ? "active"
                              : ""
                            : ""
                        }
                      >
                        {childrenItem.type === "sub" ? (
                          <a
                            href="#javascript"
                            onClick={() => toggletNavActive(childrenItem)}
                          >
                            <i className="fa fa-circle"></i>
                            {childrenItem.title}{" "}
                            <i className="fa fa-angle-right pull-right"></i>
                          </a>
                        ) : (
                          ""
                        )}

                        {childrenItem.type === "link" ? (
                          <Link
                            to={`${process.env.PUBLIC_URL}${childrenItem.path}`}
                            className={childrenItem.active ? "active" : ""}
                            onClick={() => toggletNavActive(childrenItem)}
                          >
                            <i className="fa fa-circle"></i>
                            {childrenItem.title}{" "}
                          </Link>
                        ) : (
                          ""
                        )}
                        {childrenItem.children ? (
                          <ul
                            className={`sidebar-submenu ${
                              childrenItem.active ? "menu-open" : "active"
                            }`}
                          >
                            {childrenItem.children.map(
                              (childrenSubItem, key) => (
                                <li
                                  className={
                                    childrenSubItem.active ? "active" : ""
                                  }
                                  key={key}
                                >
                                  {childrenSubItem.type === "link" ? (
                                    <Link
                                      to={`${process.env.PUBLIC_URL}${childrenSubItem.path}`}
                                      className={
                                        childrenSubItem.active ? "active" : ""
                                      }
                                      onClick={() =>
                                        toggletNavActive(childrenSubItem)
                                      }
                                    >
                                      <i className="fa fa-circle"></i>
                                      {childrenSubItem.title}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </li>
                              )
                            )}
                          </ul>
                        ) : (
                          ""
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </li>
            ) : null;
          })}
          <li
            className={`right-arrow ${
              layout === "rtl"
                ? hideRightArrowRTL
                  ? "d-none"
                  : ""
                : hideRightArrow
                ? "d-none"
                : ""
            }`}
            onClick={
              wrapper === "horizontal_sidebar" && layout === "rtl"
                ? scrollToRightRTL
                : scrollToRight
            }
          >
            <i className="fa fa-angle-right"></i>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
